<div class="wrapper embedded">
  <mat-card>
    <h1>Results</h1>
    <app-list></app-list>
  </mat-card>
</div>